import React from "react";

// Define type matching the one in App.tsx
interface RecommendedWine {
  product_id: number;
  name: string;
}

interface PairingResultProps {
  suggestion: string | null;
  error: string | null;
  recommendedWines: RecommendedWine[]; // Add the new prop
}

const PairingResult: React.FC<PairingResultProps> = ({
  suggestion,
  error,
  recommendedWines,
}) => {
  if (error) {
    // Display error in a card as well for consistency
    return (
      <div className="card red lighten-4" style={{ marginTop: "20px" }}>
        <div className="card-content red-text text-darken-2">
          <span className="card-title">Errore:</span>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  // Don't render anything if there's no suggestion yet (and no error)
  if (suggestion === null) {
    return null;
  }

  // Use Materialize Card for result display
  return (
    <div className="card blue-grey darken-1" style={{ marginTop: "20px" }}>
      {" "}
      {/* Card styling */}
      <div className="card-content white-text">
        {" "}
        {/* Card content area */}
        <span className="card-title">Suggerimento Abbinamento:</span>{" "}
        {/* Card title */}
        {/* Use whiteSpace pre-wrap to respect newlines from Gemini */}
        <p style={{ whiteSpace: "pre-wrap" }}>{suggestion}</p>
        {/* Display recommended wines if any were identified */}
        {recommendedWines && recommendedWines.length > 0 && (
          <div
            style={{
              marginTop: "20px",
              paddingTop: "10px",
              borderTop: "1px solid rgba(255,255,255,0.2)",
            }}
          >
            {" "}
            {/* Divider */}
            <h6>Vini Specifici Menzionati:</h6> {/* Smaller heading */}
            <ul>
              {recommendedWines.map((wine) => (
                <li key={wine?.product_id}>
                  {wine?.name} (ID: {wine?.product_id})
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default PairingResult; // Ensure default export is present
